/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Upgrade_DescriptionInputs */



/**
* | output |
* | --- |
* | "Review the upgrade details and confirm to proceed." |
*
* @param {Plan_Upgrade_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_upgrade_description = /** @type {((inputs?: Plan_Upgrade_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Upgrade_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Überprüfe die Upgrade-Details und bestätige, um fortzufahren.")
	return /** @type {LocalizedString} */ ("Review the upgrade details and confirm to proceed.")
});